<template>

  <section class="loading-container" :class="{ 'is-loading': $store.state.isLoading}">

    <div class="wrap">
      <p v-if="message">{{ message }}</p>
      <img src="../assets/loader.svg">
    </div>
  </section>

</template>

<script>
export default {
  name: 'Loading',
  props: ['message'],
  inherit: true
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  @import "../scss/_variables.scss";

  .loading-container {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: none;

    text-align: center;
    background: rgba(black, 0.9);

    z-index: -1;
    opacity: 0;
    transition: opacity 0.5s ease-in-out;

    .wrap {
      position: absolute;
      top: 45%;
      right: 0;
      left: 0;
      margin: auto;
    }

    p {
      margin-bottom: 5px;
      color: white;
    }

    img {
      width: 80px;
      margin: auto;
    }
  }

  .loading-container.is-loading {
    display: block;
    z-index: 99999999;
    opacity: 1;
  }

</style>
